export enum TipoBonificacionRecargo {
    Producto = 0,
    Expendedora = 1,
}
